import React from 'react'
import styled from 'styled-components'

const Container = styled.article`
  padding: ${({ theme }) => theme.gutter} 0;
  color: ${({ theme }) => theme.themeColorError};
`


const Validation = () => (
  <Container>
    Vissa obligatoriska fält är inte ifyllda. Vänligen gå igenom formuläret och fyll i de rödmarkerade fälten.
  </Container>
)

export default Validation